<template>
    <div id="study_result">
        <h1>Study Info Page {{$route.params.id}}</h1>

        <h3>Title</h3>
        {{title}}
        <h3>Abstract</h3>
        {{abstract}}
        <h3>Links</h3>
        <div v-if="links !== null">
            <a :href="first_links_href">
                <p>{{first_links_text}}</p>
            </a>

            <a v-if="links['URL'] !== null && links['LABEL'] !== null" :href="links['URL']">
                <p>{{links['LABEL']}}</p>
            </a>

        </div>
        <h3>Linked Experiments, count: {{links_to_exps.length}}</h3>

            <b-table :items="links_to_exps" :fields="fields">
                <template v-slot:cell(secondary_id)="row">
                    <router-link :to="{path: `/exp/${row.value}`}">{{row.value}}</router-link>
                </template>


            </b-table>
<!--            <div v-for="exp_id in links_to_exps" :key="exp_id['secondary_id']">-->
<!--                <router-link :to="{path: `/exp/${exp_id['secondary_id']}`}" >{{`${exp_id['secondary_id']}`}}</router-link>-->
<!--                {{exp_id['title']}}-->
<!--            </div>-->


    </div>
</template>

<script>
    import axios from 'axios'

    const fields = [
        {key:'secondary_id', label: 'ID'},
        {key: 'tissue_type', label: 'Tissue type'},
        {key: 'transcripts', label: 'Transcripts number'},
        {key: 'transcripts_out', label: 'Transcripts size, Mb'}
    ];

    export default {
        name: "StudyResult",
        data: function () {
            return {
                title: null,
                abstract: null,
                links: null,
                links_to_exps: [],
                fields: fields,
            }
        },
        mounted() {
            axios.get(`/get/study/${this.$route.params.id}`)
                .then(response => {

                    this.title = response.data['title'];
                    this.abstract = response.data['abstract'];
                    this.links_to_exps = response.data['links_to_exps'];

                    this.links = response.data['links'];
                })
        },
        computed: {
            first_links_href: function () {
                return this.links['ID'];
            },
            first_links_text: function () {
                return this.links['DB'];
            }
        }
    }
</script>

<style scoped>

</style>